export default (event, callback, buttonDisabled) => {
  if (buttonDisabled) {
    event.preventDefault();
  } else {
    callback(event);
  }
};
